class UnderstandSectionSubEntity {
    constructor(data) {
        this.fieldName = data.fieldName;
        this.description = data.description;
    }
}
export default UnderstandSectionSubEntity;
